import { ProfileType } from '../types/enums';

export interface NavItem {
    path: string;
    label: string;
    roles: ProfileType[];
}

export const NAV_CONFIG: NavItem[] = [
    { path: '/', label: 'Dashboard', roles: [ProfileType.SalonOwner, ProfileType.SuperAdmin] },
    // S2 (AB#2205, SG-06) — a staff member's home is My Day (same route, staff view).
    { path: '/', label: 'My day', roles: [ProfileType.SalonStaff] },
    // AB#1749 — Owner calendar day-view (Calendar v1, C3). Top-level surface
    // alongside Appointments. Future C5/C6 add booking flows in-page.
    { path: '/calendar', label: 'Calendar', roles: [ProfileType.SalonOwner] },
    { path: '/appointments', label: 'Appointments', roles: [ProfileType.SalonOwner, ProfileType.SalonStaff] },
    // S2 (AB#2205, SG-07) — read-only weekly hours, approved time off, salon closures.
    { path: '/schedule', label: 'My schedule', roles: [ProfileType.SalonStaff] },
    // O3 (SO-29) — one home per task: owners reach Services and Staff through
    // My Business › Services / Manage Staff (the My Business entry below), so the
    // duplicate owner sidebar entries are gone. /services and /employee still
    // redirect there (App.tsx). Staff keep the standalone /services listing.
    { path: '/services', label: 'Services', roles: [ProfileType.SalonStaff] },
    // Wave 0.5 item 6 — non-core owner + staff surfaces hidden from the pilot
    // navigation. The pages themselves are preserved (routes neutralized to
    // redirects in App.tsx), so re-enabling post-pilot is a one-line revert.
    // Hidden here: owner Promotions (/promotion), Packages (/packages),
    // Subscription (/subscription — founding salons are free in the pilot),
    // Loyalty (/loyalty), Inventory (/inventory), Referrals (/referrals);
    // staff Promotions (/promotions) and Customers (/customers).
    { path: '/payments', label: 'Payments', roles: [ProfileType.SalonOwner] },
    { path: '/settings', label: 'Settings', roles: [ProfileType.SalonOwner] },
    // AB#1675 — Onboarding shell entry-point. The "My Business" section bundles
    // Business Details, Branches, Services, Staff, Bank Details, etc., and is
    // surfaced both here in the sidebar and in the profile-menu dropdown.
    { path: '/my-business', label: 'My Business', roles: [ProfileType.SalonOwner] },
    // #1171: /settings/profile accessible for SuperAdmin and SalonStaff
    { path: '/settings/profile', label: 'Profile', roles: [ProfileType.SalonStaff, ProfileType.SuperAdmin] },
    { path: '/pending-approvals', label: 'Pending Approvals', roles: [ProfileType.SuperAdmin] },
    { path: '/users', label: 'Users', roles: [ProfileType.SuperAdmin] },
    { path: '/owners', label: 'Owners', roles: [ProfileType.SuperAdmin] },
    // Batch C (AB#2195) — find a customer's booking across salons; cancel it with a reason.
    { path: '/booking-support', label: 'Booking Support', roles: [ProfileType.SuperAdmin] },
    { path: '/feature-flags', label: 'Feature Flags', roles: [ProfileType.SuperAdmin] },
    // AB#1818 — SuperAdmin marketplace Categories management (Dina design-handoff §5.1).
    { path: '/categories', label: 'Categories', roles: [ProfileType.SuperAdmin] },
    // Wave 0.5 item 6 — non-core admin (financial/monetization) surfaces hidden
    // from the pilot navigation. Pages preserved; routes neutralized to
    // redirects in App.tsx. Hidden here: Subscription Analytics
    // (/subscription-analytics), Payment Dashboard (/payment-dashboard),
    // Gender Overrides (/gender-overrides), Platform Promotions
    // (/platform-promotions), Payouts (/payouts), Financial Transactions
    // (/financial-transactions), Financial Reports (/financial-reports),
    // Pricing Config (/pricing-config). Chat (/chat, all roles) is likewise
    // hidden as a non-core surface for the pilot.
    // GL-10 (Go-Live Wave 0): Audit Log + API Keys (404 backends → empty
    // shims) and Sponsored Placements (mock data by default) were already
    // hidden from the sidebar in PR #1458. Their routes are neutralized in
    // App.tsx.
    { path: '/help', label: 'Help', roles: [ProfileType.SalonOwner] },
    { path: '/support', label: 'Support', roles: [ProfileType.SalonOwner, ProfileType.SalonStaff, ProfileType.SuperAdmin] }
];

export function getNavItemsForRole(userType: number | null | undefined): NavItem[] {
    if (userType == null) return [];
    return NAV_CONFIG.filter(item => item.roles.includes(userType as ProfileType));
}
